import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Experience } from './pages/Experience';
import { Expertise } from './pages/Expertise';
import { Achievements } from './pages/Achievements';
import { Journey } from './pages/Journey';
import { Strengths } from './pages/Strengths';
import { Education } from './pages/Education';
import { Training } from './pages/Training';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31ayv2f5i4c5m">
      <Routes data-id="element-1" data-mp="31c9vc4zqn1rz">
        <Route element={<Layout data-id="element-3" data-mp="31cjo20c63n1d" />} data-id="element-2" data-mp="31c1iue7j1yhb">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wiyy8vkq9zd9" />} data-id="element-4" data-mp="2wka0gqyiyz29" />
          <Route path="/about" element={<About data-id="element-7" data-mp="2wi5lndz38fn7" />} data-id="element-6" data-mp="2wifgbev2vaz8" />
          <Route path="/experience" element={<Experience data-id="element-9" data-mp="28t4lsf4bmctj" />} data-id="element-8" data-mp="28u5uwe1s0p8m" />
          <Route path="/expertise" element={<Expertise data-id="element-11" data-mp="23vkuadim43jn" />} data-id="element-10" data-mp="28sbcb6dz997p" />
          <Route path="/achievements" element={<Achievements data-id="element-13" data-mp="23t8hsfvmildz" />} data-id="element-12" data-mp="23u9uspw79hyc" />
          <Route path="/journey" element={<Journey data-id="element-15" data-mp="3iiwf2oflbi38" />} data-id="element-14" data-mp="3ik7g4ghnibqn" />
          <Route path="/strengths" element={<Strengths data-id="element-17" data-mp="3mlj8gtrwtb2j" />} data-id="element-16" data-mp="3ijpbowku4r7n" />
          <Route path="/education" element={<Education data-id="element-19" data-mp="3mjztr7lwj82v" />} data-id="element-18" data-mp="3mkre1ma1tjdu" />
          <Route path="/training" element={<Training data-id="element-21" data-mp="3rbrc4uuwm7hx" />} data-id="element-20" data-mp="3mj6jvxrnc2gi" />
          <Route path="/contact" element={<Contact data-id="element-23" data-mp="3reccfffk0fdk" />} data-id="element-22" data-mp="3rdkgg3i1ofmr" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-25" data-mp="680frswe88f" />} data-id="element-24" data-mp="5otf64sd496" />
        </Route>
      </Routes>
    </BrowserRouter>;
}